(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('AsideController', AsideController);

    AsideController.$inject = ['$state', 'Principal', 'ENV', 'Macro', 'Queue', 'LicenceCode', '$rootScope'];

    function AsideController($state, Principal, ENV, Macro, Queue, LicenceCode, $rootScope) {
        var vm = this;

        // vm.isAsideCollapse = false;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.inProduction = ENV === 'prod';
        // vm.toggleAside = toggleAside;
        // vm.collapseAside = collapseAside;
        vm.$state = $state;

        vm.homeTemplate = 'app/layouts/aside/templates/home.html';
        vm.monitoringTemplate = 'app/layouts/aside/templates/monitoring.html';
        vm.controlTemplate = 'app/layouts/aside/templates/control.html';
        vm.systemTemplate = 'app/layouts/aside/templates/system.html';
        vm.alertingTemplate = 'app/layouts/aside/templates/alerting.html';
        vm.updatesTemplate = 'app/layouts/aside/templates/updates.html';
        vm.kioskTemplate = 'app/layouts/aside/templates/kiosk.html';
        vm.kioskTemplateAdmin = 'app/layouts/aside/templates/kioskAdmin.html';
        vm.testingTemplate = 'app/layouts/aside/templates/testing.html';
        vm.administrationTemplate = 'app/layouts/aside/templates/administration.html';


        vm.set

        vm.toggleAside = function() {
            if (window.screen.width <= 990) {
                $('.navbar-collapse').collapse('hide');
            }
        }

        // function collapseAside() {
        //     vm.isAsideCollapse = true;
        // }

        Macro.query({id: -1, page: vm.page}, onSuccessMacro, onErrorMacro);

        LicenceCode.activeLicence({id: -1, page: vm.page}, onSuccess, onError);

        function onSuccessMacro(data) {
            vm.macro = [];
            for (var i = 0; i < data.length; i++) {
                vm.macro.push(data[i]);
            }
            if (vm.macro.length != 0) {
                vm.showMacro = true;
            }

        }

        function onErrorMacro() {

        }

        function onSuccess(data) {
            if (data.length > 0) {
                vm.showLicences = true;
            }
        }

        function onError() {
        }

        //close open tab on click on other menu element
        var $myGroup = $('.page-sidebar-menu');
        $myGroup.on('show.bs.collapse', '.collapse', function () {
            $myGroup.find('.collapse.in').collapse('hide');
        });
        $('.page-sidebar-menu > li > a.nav-link:not(.nav-toggle)').on('click', function () {
            $myGroup.find('.collapse.in').collapse('hide');
        });

    }
})();
